module.exports = __webpack_public_path__ + "img/home-page-bg-image.fce5b5f1.jpg";